// src/components/notifications/NotificationsFilters.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
} from '@mui/material';

export default function NotificationsFilters({
  show,
  searchQuery,
  filterType,
  filterPriority,
  filterRead,
  onSearchChange,
  onTypeChange,
  onPriorityChange,
  onReadStatusChange,
  onClearFilters,
}) {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('notifications:filters.title')}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label={t('notifications:filters.search')}
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={t('notifications:filters.search_placeholder')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="notifications-filters-type-label">{t('notifications:labels.type')}</InputLabel>
              <Select labelId="notifications-filters-type-label"
                value={filterType}
                label={t('notifications:labels.type')}
                onChange={(e) => onTypeChange(e.target.value)}
              >
                <MenuItem value="all">{t('notifications:filters.all_types')}</MenuItem>
                <MenuItem value="info">{t('notifications:notification_types.info')}</MenuItem>
                <MenuItem value="warning">{t('notifications:notification_types.warning')}</MenuItem>
                <MenuItem value="error">{t('notifications:notification_types.error')}</MenuItem>
                <MenuItem value="success">{t('notifications:notification_types.success')}</MenuItem>
                <MenuItem value="task_assigned">{t('notifications:notification_types.task_assigned')}</MenuItem>
                <MenuItem value="task_completed">{t('notifications:notification_types.task_completed')}</MenuItem>
                <MenuItem value="deadline_reminder">{t('notifications:notification_types.deadline_reminder')}</MenuItem>
                <MenuItem value="system_update">{t('notifications:notification_types.system_update')}</MenuItem>
                <MenuItem value="maintenance">{t('notifications:notification_types.maintenance')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="notifications-filters-priority-label">{t('notifications:labels.priority')}</InputLabel>
              <Select labelId="notifications-filters-priority-label"
                value={filterPriority}
                label={t('notifications:labels.priority')}
                onChange={(e) => onPriorityChange(e.target.value)}
              >
                <MenuItem value="all">{t('notifications:filters.all_priorities')}</MenuItem>
                <MenuItem value="urgent">{t('notifications:priority.urgent')}</MenuItem>
                <MenuItem value="high">{t('notifications:priority.high')}</MenuItem>
                <MenuItem value="normal">{t('notifications:priority.normal')}</MenuItem>
                <MenuItem value="low">{t('notifications:priority.low')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="notifications-filters-status-label">{t('notifications:labels.status')}</InputLabel>
              <Select labelId="notifications-filters-status-label"
                value={filterRead}
                label={t('notifications:labels.status')}
                onChange={(e) => onReadStatusChange(e.target.value)}
              >
                <MenuItem value="all">{t('notifications:filters.all_status')}</MenuItem>
                <MenuItem value="unread">{t('notifications:filters.unread')}</MenuItem>
                <MenuItem value="read">{t('notifications:filters.read')}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Stack direction="row" spacing={1}>
              <Button size="small" onClick={onClearFilters}>
                {t('notifications:filters.clear_filters')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}